import { ThemeProvider } from "styled-components";
import { MSButtonContainer } from "./MSButtonStyles";
import { token } from "../../theme";

const MSButton = ({
  children,
  onClick,
  style,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
}) => {
  return (
    <ThemeProvider theme={token}>
      <MSButtonContainer
        style={{ ...style }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {children}
      </MSButtonContainer>
    </ThemeProvider>
  );
};

export default MSButton;
